export enum UserActionType {
    User_INIT = 'USER_INIT'
}

export enum DynamikModulsActionType {
    DynamikModuls_INIT = 'DYNAMIKMODULS_INIT'
}
